import { gql } from '@apollo/client';

export const ASSIGN_INSPECTOR_V2 = gql`
  mutation assignInspectorV2($data: AssignInspectionInputV2!, $workshopId: String!) {
      assignInspectionToCgtV2(data: $data, workshopId: $workshopId) {
        success
    }
  }
`;

export const SUGGEST_CGT = gql`
  mutation suggestCgt($workshopId: String!) {
    suggestCgt(workshopId: $workshopId) {
      success
      errorMessage
    }
  }
`;

export const ADD_CAR_AND_ASSIGN = gql`
  mutation addCarAndAssignInspectionToCgt($data: AddCarAndAssignInspectionToCGTInput!, $workshopId: String!) {
    addCarAndAssignInspectionToCgt(data: $data, workshopId: $workshopId) {
      success
    }
  }
`;

export const ASSIGN_CGT = gql`
    mutation assignCGT($refurbCarId: String!, $userId: String!, $assignedWorkshopId: String!, $workshopId: String!){
        assignInspectionToCgt(data:{refurbCarId: $refurbCarId, userId: $userId, workshopId: $assignedWorkshopId }, workshopId: $workshopId){
            success
            messages
        }
      }
`;